var isDisjoint = function isDisjoint() {
  for (var _len = arguments.length, headers = new Array(_len), _key = 0; _key < _len; _key++) {
    headers[_key] = arguments[_key];
  }

  var sources = headers.filter(Boolean);

  if (sources.length === 0 || sources.length === 1) {
    return true;
  }

  var acc;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var header = _step.value;
      var parameters = Object.keys(header);

      if (!acc || acc.size === 0) {
        acc = new Set(parameters);
        continue;
      }

      for (var _i = 0, _parameters = parameters; _i < _parameters.length; _i++) {
        var parameter = _parameters[_i];

        if (acc.has(parameter)) {
          return false;
        }

        acc.add(parameter);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return true;
};

export default isDisjoint;